import { ReportsDownload } from '../constants/features';
import { usePlanFeatureGate } from './use-plan-feature-gate';

export const useReportsDownloadFeatureGate = () => usePlanFeatureGate(ReportsDownload);
